/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-otg-2': {
    width: 32.1,
    height: 44.66,
    viewBox: '0 0 32.1 44.66',
    data: '<defs><style>.cls-1{fill:#252525;}</style></defs><title>compass-shape</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1" points="16.3 0 32.1 44.66 16.11 34.49 0 44.47 16.3 0"/></g></g>'
  }
})
